import fwImg from '@/assets/card/fwImg';
import ssImg from '@/assets/card/ssImg';

import Card from './Card';

const SeasonalCard = ({ cardId, width, height }) => {
	const imageArray = cardId < 100 ? ssImg : fwImg;

	return (
		<Card
			cardId={cardId}
			width={width}
			height={height}
			cardImageArray={imageArray}
		/>
	);
};

export default SeasonalCard;
